import { render, staticRenderFns } from "./UpdateMovementCollection.vue?vue&type=template&id=ee76c88c&scoped=true&"
import script from "./UpdateMovementCollection.vue?vue&type=script&lang=js&"
export * from "./UpdateMovementCollection.vue?vue&type=script&lang=js&"
import style0 from "./UpdateMovementCollection.vue?vue&type=style&index=0&id=ee76c88c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee76c88c",
  null
  
)

export default component.exports